import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FuseLoading from '@fuse/core/FuseLoading';
import LoadingDialog from 'app/admin/common/LoadingDialog';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Typography, Button, Icon } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { withRouter, useHistory } from 'react-router-dom';
import _ from '@lodash';
import { useForm, FormProvider, useWatch } from 'react-hook-form';
import FeltoltesAdatlapFirstStep from './FeltoltesAdatlapFirstStep';
import VizsgaService from '../../feltoltestesztlap/service/VizsgaService';
import FeltoltesAdatlapSecondStep from './FeltoltesAdatlapSecondStep';
import AdatlapService from '../service/AdatlapService';

const schema = yup.object().shape({
	examId: yup.number().nullable().required('Kötelező mező.'),
	paperType: yup.string().nullable().required('Kötelező mező.'),
	description: yup.string().nullable().required('Kötelező mező.')
});

function FeltoltesAdatlapSubmitForm(props) {
	const dispatch = useDispatch();
	const history = useHistory();
	const [initStatus, setInitStatus] = useState('loading');
	const [loading, setLoading] = useState(false);
	const [selectedFileCount, setSelectedFileCount] = useState(0);
	const [examList, setExamList] = useState(null);
	const [uploadDto, setUploadDto] = useState(null);
	const theme = useTheme();
	const user = useSelector(({ auth }) => auth.user);
	const methods = useForm({
		mode: 'onChange',
		defaultValues: {
			examId: null,
			paperType: 'adatlap_kepek',
			description: null,
			packageName: null
		},
		resolver: yupResolver(schema)
	});
	const { formState, getValues, reset, control, clearErrors, setError, setValue } = methods;

	const watchPackageNameFields = useWatch({
		name: ['examId', 'paperType'],
		control
	});

	useEffect(() => {
		let result = '';
		if (watchPackageNameFields[0]) {
			result += `${examList.find(d => d.id === watchPackageNameFields[0]).escaped}_`;
		} else {
			result += '[vizsganév]_[vizsgaid]_';
		}
		if (watchPackageNameFields[1]) {
			result += `${watchPackageNameFields[1]}_`;
		} else {
			result += '[laptipus]_';
		}
		result += `${user.data.id}_`;
		setValue('packageName', result);
	}, [watchPackageNameFields]);

	useEffect(() => {
		VizsgaService.getUnLockedSelection().then(response => {
			setExamList(response);
			setInitStatus('done');
		});
	}, []);

	const handleSave = () => {
		clearErrors();
		const values = getValues();
		if (selectedFileCount > 0) {
			const newUploadDto = {
				packageName: values.packageName + values.description,
				paperType: values.paperType,
				examId: values.examId
			};
			AdatlapService.createFolder(newUploadDto.packageName, newUploadDto.paperType, newUploadDto.examId).then(resp => {
				if (resp) {
					setUploadDto(newUploadDto);
				} else {
					dispatch(showMessage({ message: 'Hiba történt a könyvtár létrehozása során.' }));
				}
			});
		} else {
			dispatch(showMessage({ message: 'Fájlok megadása kötelező' }));
		}
	};

	const handleUploadDone = successful => {
		setUploadDto(null);
		if (successful) {
			dispatch(showMessage({ message: 'Feltöltések sikeresen végrehajtva.' }));
		} else {
			dispatch(showMessage({ message: 'Hiba történt a tábla bejegyzések létrehozása során.' }));
		}
		history.push('/feltoltesadatlap');
	};

	return (
		<FormProvider {...methods}>
			<FusePageCarded
				classes={{
					root: initStatus !== 'done' ? 'hidden' : null,
					toolbar: 'p-0',
					header: 'min-h-72 h-72 sm:h-136 sm:min-h-136'
				}}
				header={
					<div className="flex flex-1 w-full items-center justify-between">
						<div className="flex flex-col items-start max-w-full min-w-0">
							<motion.div initial={{ x: 20, opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}>
								<Typography className="flex items-center sm:mb-12" component={Button} role="button" onClick={() => history.goBack(history)} color="inherit">
									<Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
									<span className="hidden sm:flex mx-4 font-medium">Vissza</span>
								</Typography>
							</motion.div>

							<div className="flex items-center max-w-full">
								<div className="flex flex-col min-w-0 mx-8 sm:mc-16">
									<motion.div initial={{ x: -20 }} animate={{ x: 0, transition: { delay: 0.3 } }}>
										<Typography className="text-16 sm:text-20 truncate font-semibold">Adatlapok feltöltése</Typography>
									</motion.div>
								</div>
							</div>
						</div>
						<motion.div className="flex" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}>
							<Button className="whitespace-nowrap mx-4" variant="contained" color="secondary" onClick={methods.handleSubmit(handleSave)} startIcon={<Icon className="hidden sm:flex">save</Icon>} disabled={uploadDto != null}>
								Beküldés
							</Button>
						</motion.div>
					</div>
				}
				content={
					<div className="p-16 sm:p-24">
						<FeltoltesAdatlapFirstStep examList={examList} />
						<FeltoltesAdatlapSecondStep onSelectedFileCount={count => setSelectedFileCount(count)} uploadDto={uploadDto} onUploadDone={successful => handleUploadDone(successful)} />
					</div>
				}
			/>
			{initStatus === 'loading' ? <FuseLoading /> : null}
			{loading && <LoadingDialog content="Adatlapok felvitele folyamatban" />}
		</FormProvider>
	);
}

export default withRouter(FeltoltesAdatlapSubmitForm);
